export default __webpack_public_path__ + "static/repeat-do-5e3574baedd2b7603a430a45585006cb20df16f4c257aa7977a2046f65bb001a.png";